import React from 'react';
import { useTranslation } from "react-i18next";
import { Form } from 'react-bootstrap';

export function FormCheckHelper(language) {
  const { t } = useTranslation();
  return <Form.Check custom type={"checkbox"} id={"js-form-lang-" + language} label={t("form-lang-" + language)} name={"lang-" + language} />;
}
